import StandardRestError from './Standard'

class ChatCreditsExhaustedError extends StandardRestError {
  static CODE = 'CHAT_CREDITS_EXHAUSTED'

  constructor(
    message = 'Chat credit budget reached.',
    status = 402,
    body = {},
  ) {
    super(message)
    this.status = status
    this.body = body
  }
}

export default ChatCreditsExhaustedError
